/** Mongo ObjectId hex used by shell detail routes (API path params). */
const SHELL_OBJECT_ID_RE = /^[a-f0-9]{24}$/i;

/**
 * React Router v6 dropped path regex constraints (`:id([a-f0-9]{24})`).
 * Validate ObjectId-shaped params in app code so static siblings like
 * `/locations/create` or `/products/setup` are never treated as detail ids.
 */
export function isShellObjectIdParam(
  value: string | undefined | null,
): value is string {
  return typeof value === 'string' && SHELL_OBJECT_ID_RE.test(value);
}
